import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Child } from '../interfaces/child.interface';
import { PinInputModalComponent } from '../shared/components/pin-input-modal/pin-input-modal.component';
import { ChildAuthService } from './child-auth.service';
import { firstValueFrom } from 'rxjs';
import { LoginRequiredModalComponent } from '../shared/components/login-required-modal/login-required-modal.component';

@Injectable({
  providedIn: 'root'
})
export class ChildLoginService {
  constructor(
    private dialog: MatDialog,
    private childAuth: ChildAuthService
  ) {}

  async attemptChildLogin(child: Child): Promise<boolean> {
    if (!child.pin) {
      console.log('Child has no PIN set, automatically logging in');
      this.childAuth.loginChild(child);
      return true;
    }

    const dialogRef = this.dialog.open(PinInputModalComponent, {
      data: { child },
      disableClose: true
    });

    const enteredPin = await firstValueFrom(dialogRef.afterClosed());
    
    if (enteredPin === child.pin) {
      this.childAuth.loginChild(child);
      return true;
    }
    
    return false;
  }

  showLoginRequiredModal() {
    this.dialog.open(LoginRequiredModalComponent);
  }
} 